module.exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "a.m./p.m.",
  "endDate": "Einddatum",
  "era": "tijdperk",
  "hour": "uur",
  "minute": "minuut",
  "month": "maand",
  "second": "seconde",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Geselecteerde datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Geselecteerd bereik: ".concat(args.startDate, " tot ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Geselecteerde tijd: ".concat(args.time);
  },
  "startDate": "Startdatum",
  "timeZoneName": "tijdzone",
  "weekday": "dag van de week",
  "year": "jaar"
};